import { render, staticRenderFns } from "./ContractRelatedMatters.vue?vue&type=template&id=d36c7c3e&scoped=true"
import script from "./ContractRelatedMatters.vue?vue&type=script&lang=js"
export * from "./ContractRelatedMatters.vue?vue&type=script&lang=js"
import style0 from "./ContractRelatedMatters.vue?vue&type=style&index=0&id=d36c7c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36c7c3e",
  null
  
)

export default component.exports